import React from 'react';
import { Tooltip } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  tooltipContent: {
    height: 'auto',
    lineHeight: 1,
  },
}));

const TooltipWrapper = ({ children, title }) => {
  const classes = useStyles();

  return (
    <Tooltip title={title}>
      <span className={classes.tooltipContent}>{children}</span>
    </Tooltip>
  );
};

export default TooltipWrapper;
